<template>          
    <BasePanel headline="lang_PUBLISHING_TRACKING_PANEL_CAPTION_PRO_LISTS">    
        <template v-slot:panelContent>
            <ValidationObserver
                ref="editForm"
                v-slot="{ invalid, validated, validate, passes}"
            >
                <BaseInlineEditingDataTable
                    :headers="headers"
                    :context="context" 
                >
                    <template v-slot:topSlot>
                        <ProlistsPanelTopSlot :validation="passes" />                    
                    </template>
                    <template v-slot:editRow="{ items }">                        
                        <ProlistsEditRow :items="items" />                             
                    </template>
                </BaseInlineEditingDataTable>
            </ValidationObserver>
        </template>                 
    </BasePanel>
</template>

<script>
import BaseInlineEditingDataTable from '@/components/_base/BaseInlineEditingDataTable'
import BasePanel from '@/components/_base/BasePanel'
import ProlistsPanelTopSlot from './ProlistsPanelTopSlot'
import ProlistsEditRow from './_buttons/ProlistsEditRow'

export default {
    name: "ProlistsPanel",
    components: {
        BaseInlineEditingDataTable,
        BasePanel,
        ProlistsPanelTopSlot,
        ProlistsEditRow
    },
    data() {
        return {
            context: "Prolists"
        }
    },
    computed: {			        
		/** Returns an Array with header-objects with props.
         *  @return {[{text: String, align: string, value: string}]} props of the header */        
        headers() {
            return [
                {text: this.$t('lang_PUBLISHING_TRACKING_PROLISTS_PANEL_CAPTION_CATEGORY'), align: 'left', value: 'category', class: 'text-no-wrap', width: '10%'},
                {text: this.$t('lang_PUBLISHING_TRACKING_PROLISTS_PANEL_CAPTION_FILE'), align: 'left', value: 'fileName', class: 'text-no-wrap', width: '40%'},
                {text: this.$t('lang_PUBLISHING_TRACKING_PROLISTS_PANEL_CAPTION_YEAR'), align: 'right', value: 'year', class: 'text-no-wrap'},
                {text: this.$t('lang_PUBLISHING_TRACKING_PROLISTS_PANEL_CAPTION_RECORDS'), align: 'right', value: 'rows', class: 'text-no-wrap'},
                {text: this.$t('lang_PUBLISHING_TRACKING_PROLISTS_PANEL_CAPTION_IMPORT_DATE'), align: 'left', value: 'importDate', class: 'text-no-wrap'},
                {text: '', align: 'right', value: 'downloadLink', width: "50px"},
                {text: '', align: 'right', value: 'delete', width: "50px"}  
            ]
        }
    }
}
</script>